var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.customerDetails != null
    ? _c("div", [
        _c("div", { staticClass: "md-layout" }, [
          _c("div", { staticClass: "md-layout-item" }, [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c("div", { staticClass: "custom-toolbar-start" }, [
                _c("h3", { staticClass: "title" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.customerDetails.name) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "md-layout md-alignment-top-left content-layout-panel",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xlarge-size-100",
                  },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-green",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-icon" },
                              [_c("md-icon", [_vm._v("description")])],
                              1
                            ),
                          ]
                        ),
                        _c("md-card-content", [
                          _c("div", { staticClass: "flex-container" }, [
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("ABN")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.customerDetails
                                        .businessRegistrationNumber
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Customer Code")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.customerCode) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Company")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.company) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("First name")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.firstName) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Last name")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.lastName) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Address")]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.customerDetails.address) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "flex-container" }, [
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Phone")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.phone) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Email")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.email) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "details-box" }, [
                              _c("label", [_vm._v("Contact Email")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.customerDetails.contactEmail) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Default Stop Notes")]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.customerDetails.defaultStopNotes) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Payment Terms (Days)")]),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.customerDetails.paymentTermsInDays
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                  },
                  [
                    _c("notes", {
                      attrs: {
                        list: _vm.customerDetails.latestNotes,
                        "customer-id": _vm.customerDetails.customerId,
                      },
                      on: { notesAdded: _vm.handleAddedStopNote },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50",
              },
              [
                _c(
                  "md-card",
                  [
                    _c(
                      "md-card-header",
                      {
                        staticClass: "md-card-header-icon md-card-header-blue",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-icon" },
                          [_c("md-icon", [_vm._v("directions_bus")])],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "md-card-content",
                      [
                        !_vm.$root.isMobileOnly
                          ? _c(
                              "md-table",
                              [
                                _c(
                                  "md-table-row",
                                  [
                                    _c("md-table-head", [_vm._v("Stop Ref")]),
                                    _c("md-table-head", [_vm._v("Status")]),
                                    _c("md-table-head", [_vm._v("Trip date")]),
                                    _c("md-table-head", [_vm._v("Address")]),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.customerDetails.lastVisitedStops,
                                  function (stop) {
                                    return _c(
                                      "md-table-row",
                                      { key: stop.stopId },
                                      [
                                        _c(
                                          "md-table-cell",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "normal-link",
                                                attrs: {
                                                  to: {
                                                    name: "Stop Details",
                                                    params: {
                                                      stopId: stop.stopId,
                                                    },
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(stop.stopRef) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("md-table-cell", [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom-badge",
                                              class:
                                                "status-" +
                                                stop.status
                                                  .replace(/\s/g, "")
                                                  .toLowerCase(),
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(stop.status) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm._f("dateFormat")(
                                                  stop.tripDate,
                                                  _vm.DATE_TYPES.standardDate
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                stop.addressComponents != null
                                                  ? stop.addressComponents
                                                      .address
                                                  : stop.address
                                              ) +
                                              "\n                            "
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "mobile-stop-info" },
                                _vm._l(
                                  _vm.customerDetails.lastVisitedStops,
                                  function (stop) {
                                    return _c(
                                      "div",
                                      {
                                        key: stop.stopId,
                                        staticClass: "stop-info",
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("strong", [_vm._v("Stop Ref:")]),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "normal-link",
                                                attrs: {
                                                  to: {
                                                    name: "Stop Details",
                                                    params: {
                                                      stopId: stop.stopId,
                                                    },
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(stop.stopRef) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("div", [
                                          _c("strong", [_vm._v("Status:")]),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom-badge",
                                              class:
                                                "status-" +
                                                stop.status
                                                  .replace(/\s/g, "")
                                                  .toLowerCase(),
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(stop.status) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("div", [
                                          _c("strong", [_vm._v("Trip Date:")]),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm._f("dateFormat")(
                                                  stop.tripDate,
                                                  _vm.DATE_TYPES.standardDate
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]),
                                        _c("div", [
                                          _c("strong", [_vm._v("Address:")]),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                stop.addressComponents != null
                                                  ? stop.addressComponents
                                                      .address
                                                  : stop.address
                                              ) +
                                              "\n                                "
                                          ),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }